import { parseTimeToMinutes } from '@/schedule/scheduleUtils';

/** Уровень «S» в FONT_SIZE_LEVELS / Session.font_size (запись/правки ≤30 мин) */
export const SESSION_FONT_SIZE_S = 1;

/** Уровень «M» в FONT_SIZE_LEVELS / Session.font_size */
export const SESSION_FONT_SIZE_M = 2;

/** Уровень «L» в FONT_SIZE_LEVELS / Session.font_size */
export const SESSION_FONT_SIZE_L = 3;

/** Порог «короткой» сессии для записи/правок: ≤30 — S, 31–60 — M */
const HALF_HOUR = 30;
/** Верхняя граница M для записи/правок */
const SIXTY = 60;
/** Порог для заметок: M только ≤30, иначе L */
const NOTE_SHORT_MAX = 30;

/** Типы сессий, для которых не пересчитываем шрифт по длительности (только вручную / из БД). */
const SESSION_TYPES_SKIP_DURATION_FONT = new Set<string>(['монтаж']);

function normalizeType(sessionType: string | null | undefined): string | null {
  if (sessionType == null) return null;
  const t = String(sessionType).trim();
  return t.length ? t : null;
}

/** Длительность сессии в минутах (конец − начало), неотрицательная. */
export function sessionDurationMinutes(start: string, end: string): number {
  return Math.max(0, parseTimeToMinutes(end) - parseTimeToMinutes(start));
}

/**
 * Автошрифты по длительности — подмешивать в запрос **только** когда слот по длительности или типу реально изменился
 * (см. `useScheduleLogic` и серверный PATCH). Отдельно при создании сессии — всегда.
 *
 * - **монтаж** — null.
 * - **заметка** — M если ≤30 мин, иначе L.
 * - **запись / правки** — S / M / L по порогам.
 */
export function autoFontSizePatchForDuration(
  start: string,
  end: string,
  sessionType?: string | null
): { font_size: number; second_project_font_size: number } | null {
  const st = normalizeType(sessionType);
  if (st && SESSION_TYPES_SKIP_DURATION_FONT.has(st)) {
    return null;
  }
  const d = sessionDurationMinutes(start, end);
  if (d <= 0) return null;

  if (st === 'заметка') {
    if (d <= NOTE_SHORT_MAX) {
      return { font_size: SESSION_FONT_SIZE_M, second_project_font_size: SESSION_FONT_SIZE_M };
    }
    return { font_size: SESSION_FONT_SIZE_L, second_project_font_size: SESSION_FONT_SIZE_L };
  }

  if (st === 'запись' || st === 'правки') {
    if (d <= HALF_HOUR) {
      return { font_size: SESSION_FONT_SIZE_S, second_project_font_size: SESSION_FONT_SIZE_S };
    }
    if (d <= SIXTY) {
      return { font_size: SESSION_FONT_SIZE_M, second_project_font_size: SESSION_FONT_SIZE_M };
    }
    return { font_size: SESSION_FONT_SIZE_L, second_project_font_size: SESSION_FONT_SIZE_L };
  }

  if (d <= SIXTY) {
    return { font_size: SESSION_FONT_SIZE_M, second_project_font_size: SESSION_FONT_SIZE_M };
  }
  return { font_size: SESSION_FONT_SIZE_L, second_project_font_size: SESSION_FONT_SIZE_L };
}
